module.exports = __webpack_public_path__ + "img/FooterImg.6acf2383.png";